import { render } from "./PageItem.vue?vue&type=template&id=608206ca&scoped=true&ts=true&lang=html"
import script from "./PageItem.vue?vue&type=script&lang=ts"
export * from "./PageItem.vue?vue&type=script&lang=ts"

import "./PageItem.vue?vue&type=style&index=0&id=608206ca&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608206ca"]])

export default __exports__